const cn = {
  '我已线下汇款，下一步': '我已线下汇款，下一步',
  提交: '提交',
  操作流程: '操作流程',
  通过推荐的银行汇款至我们的银行账户: '1.通过推荐的银行汇款至我们的银行账户',
  '登录您的APP，创建充值申请单': '2.登录您的APP，创建充值申请单',
  '打开个人中心-我的钱包，找到预付款充值功能':
    '① 打开个人中心-我的钱包，找到预付款充值功能',
  '② 转账完毕后，填写转账申请，填写转账信息':
    '转账完毕后，填写转账申请，填写转账信息',
  上传凭证: '③ 上传凭证',
  提交申请: '④ 提交申请',
  '我们的财务人员确认资金到账后，会通过充值申请，并为您充值':
    '3.我们的财务人员确认资金到账后，会通过充值申请，并为您充值',
  线下汇款: '线下汇款',
  填写申请: '填写申请',
  充值结果: '充值结果',
  银行名称: '银行名称',
  银行账户: '银行账户',
  收款人: '收款人',
  汇款备注: '汇款备注',
  上传凭证图片: '上传凭证图片',
  请上传如图所示的银行汇款回单照片: '请上传如图所示的银行汇款回单照片',
  预约日期: '预约日期',
  选择日期: '选择日期',
  选择时间: '选择时间',
  银行列表: '银行列表',
  请选择汇款银行: '请选择汇款银行',
  请输入汇款银行账户: '请输入汇款银行账户',
  请输入汇款人姓名: '请输入汇款人姓名',
  '充值金额:0.01~50000.00': '充值金额:0.01~50000.00',
  请选择实际汇款时间: '请选择实际汇款时间',
  收据: '收据',
  上传成功: '上传成功',
  上传失败: '上传失败',
  '正在审核中，预计1～2个工作日内到账，请您耐心等待。您可在申请记录中查看。':
    '正在审核中，预计1～2个工作日内到账，请您耐心等待。您可在申请记录中查看。',
  申请编号: '申请编号',
  申请金额: '申请金额',
  汇款时间: '汇款时间',
  凭证: '凭证',
  财务审核通过: '财务审核通过',
  提交申请成功: '提交申请成功',
  提交申请失败: '提交申请失败',
  财务审核不通过: '财务审核不通过',
  充值确认中: '充值确认中',
  注意事项: '注意事项',
  '为了确保您审核成功，请您在打款时仔细核对官方账号填写是否正确':
    '1.为了确保您审核成功，请您在打款时仔细核对官方账号填写是否正确',
  请您务必在填汇款备注中填写您的驿站编码以便我们核对您的汇款信息:
    '2.请您务必在填汇款备注中填写您的驿站编码以便我们核对您的汇款信息',
  取消: '取消',
  确定: '确定',
  兑换时间: '兑换时间',
  确认送达: '确认送达',
  取消兑换: '取消兑换',
  是否取消兑换: '是否取消兑换',
  是否确认送达: '是否确认送达',
  提示: '提示',
  已取消: '已取消',
  已确认到达: '已确认到达',
  没有更多了: '没有更多了',
  筛选: '筛选',
  兑换记录: '兑换记录',
  充值记录: '充值记录',
  '兑换状态(多选)': '兑换状态(多选)',
  '状态(多选)': '状态(多选)',
  全部: '全部',
  处理中: '处理中',
  已驳回: '已驳回',
  待确认: '待确认',
  已确认: '已确认',
  审核中: '审核中',
  成功: '成功',
  失败: '失败',
  合计: '合计',
  剩余积分: '剩余积分',
  '积分不足，去充值': '积分不足，去充值',
  兑换: '兑换',
  我的积分: '我的积分',
  积分兑换: '积分兑换',
  充值积分可兑换物料: '充值积分可兑换物料',
  积分充值: '积分充值',
  积分兑换物料: '积分兑换物料',
  兑换成功: '兑换成功',
  兑换须知: '兑换须知',
  商品详情: '商品详情',
  订单详情: '订单详情',
  实付积分: '实付积分',
  订单编号: '订单编号',
  '姓名长度为1-50位': '姓名长度为1-50位',
  '银行账号长度为1-50位': '银行账号长度为1-50位',
  '请输入0.01到50000.00之间的金额': '请输入0.01到50000.00之间的金额',
  充值成功: '充值成功',
  积分明细: '积分明细',
  从: '从',
  到: '到',
  时间: '时间',
  '1.积分一经兑换不可退还,请谨慎兑换': '积分一经兑换不可退还,请谨慎兑换',
  '2.兑换成功后,平台将在5个工作日内送达,请耐心等待':
    '兑换成功后,平台将在5个工作日内送达,请耐心等待',
  汇款人: '汇款人',
  本月达成情况: '本月达成情况',
  '奖励(积分)': '奖励(积分)',
  增长量: '增长量',
  上月揽收: '上月揽收',
  本月揽收: '本月揽收',
  冲单激励: '冲单激励',
  上月奖励排行: '上月奖励排行',
  排名: '排名',
  站点名称: '站点名称',
  兑换结果: '兑换结果',
  可在兑换记录中查看: '可在兑换记录中查看',
  支付失败: '支付失败',
  兑换失败: '兑换失败',
  继续兑换: '继续兑换',
  去查看: '去查看',
  查看其他物料商品: '查看其他物料商品',
  充值失败: '充值失败',
  请输入正确的金额: '请输入正确的金额',
  取消兑换成功: '取消兑换成功',
  暂无数据: '暂无数据',
  兑换方式: '兑换方式',
  赠送积分: '赠送积分',
  充值积分: '充值积分',
  剩余赠送积分: '剩余赠送积分',
  剩余充值积分: '剩余充值积分',
  删除: '删除',
  'JMS系统驿站账户未开账，请联系管理员': 'JMS系统驿站账户未开账，请联系管理员',
  '积分充值财务异常,请联系客服': '积分充值财务异常,请联系客服',
  不存在审核中的积分充值记录: '不存在审核中的积分充值记录',
  不存在处理中的兑换记录: '不存在处理中的兑换记录',
  参数积分总价与实际总价不符: '参数积分总价与实际总价不符',
  '账户中积分余额不足,请充值': '账户中积分余额不足,请充值',
  物料申请数据未找到: '物料申请数据未找到',
  '物料兑换申请已被审核,无法取消': '物料兑换申请已被审核,无法取消',
  物料信息未找到: '物料信息未找到',
  '积分充值失败,请联系客户': '积分充值失败,请联系客户',
  '积分充值金额必须要在0.01~50000.00范围内':
    '积分充值金额必须要在0.01~50000.00范围内',
  '当前物料兑换信息无法取消兑换,请刷新数据':
    '当前物料兑换信息无法取消兑换,请刷新数据',
  '问题反馈已回复,请勿重复提交': '问题反馈已回复,请勿重复提交',
  未知错误: '',
  寄件提成: '寄件提成',
  揽收量汇总: '揽收量汇总',
  '提成金额汇总(PHP)': '提成金额汇总(PHP)',
  平台件: '平台件',
  回退件: '回退件',
  散户: '散户',
  运单编码: '运单编码',
  请输入运单编码: '请输入运单编码',
  订单来源: '订单来源',
  订单来源类型: '订单来源类型',
  寄件日期: '寄件日期',
  入库日期: '入库日期',
  重置: '重置',
  时间间隔不能超过31天: '时间间隔不能超过31天',
  结束日期不能早于开始日期: '结束日期不能早于开始日期',
  提成金额: '提成金额',
  总运费: '总运费',
  充值金额无法退款: '3.充值金额无法退款',
  '确认进行兑换吗？': '确认进行兑换吗？',
  确认: '确认',
  平台件取消上传: '平台件取消上传',
  取消时间: '取消时间',
  审核时间: '审核时间',
  寄件入库时间: '寄件入库时间',
  已完成: '已完成',
  待上传: '待上传',
  查看详情: '查看详情',
  编辑: '编辑',
  上传: '上传',
  待审核: '待审核',
  TermOfUse: '用户条款',
  privacyPolicy: '隐私政策',
  签收照片: '签收照片',
  上传确认图片: '上传确认图片'
}

export default cn
